module.exports = __webpack_public_path__ + "static/postbetterux-1cf904605cfa3c45c9fd64d645e137d6.png";